// components/AuthContext.js
import React, { createContext, useState } from 'react';

// Create the Auth context
export const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState(null); // State to store user role

    // Define login and logout functions
    const login = (role) => {
        setIsAuthenticated(true);
        setUserRole(role); // Store the user's role upon login
    };

    const logout = () => {
        setIsAuthenticated(false);
        setUserRole(null); // Clear the user's role upon logout
    };

    return (
        <AuthContext.Provider
            value={{
                isAuthenticated,
                userRole, // Provide userRole in the context
                login,
                logout,
            }}>
            {children}
        </AuthContext.Provider>
    );
};
